import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const AccountMainContainer = styled.div<React.CSSProperties>`
  position: fixed;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  left: ${68 * Screen.widthRatio}px;
  margin-left: ${72 * Screen.widthRatio}px;
  margin-top: ${100 * Screen.widthRatio}px;
  height: ${880 * Screen.widthRatio}px;
  width: ${1660 * Screen.widthRatio}px;
`;

export default withAnimation(AccountMainContainer);
